import React, { forwardRef, useImperativeHandle, useMemo, useRef } from "react";
import { RCCSpreadsheet } from "react-common-components";
import { IRefSpreadsheet } from "react-common-components/dist/components/Spreadsheet/interface";
import { useTranslation } from "src/context/Translations/context";
import { defaultStateSchedule } from "src/pages/Config/Users/interface";
import { IRefSchedule, IScheduleRestriction } from "./interface";

// import { Container } from './styles';
function GetArray(quant: number, value: any) {
	const array = [];

	for (let i = 0; i < quant; i += 1) {
		array.push(value);
	}

	return array;
}

const ScheduleRestriction: React.ForwardRefRenderFunction<IRefSchedule, IScheduleRestriction> = ({
	data
}, ref) => {
	const {translate} = useTranslation();
	const spreadsheetRef = useRef<IRefSpreadsheet>(null);

	const getFirstColumn = (idx: number) => {
		switch(idx){
		case 0:
			return translate("Semana Inteira");
		case 1:
			return translate("Domingo");
		case 2:
			return translate("Segunda");
		case 3:
			return translate("Terça");
		case 4:
			return translate("Quarta");
		case 5:
			return translate("Quinta");
		case 6:
			return translate("Sexta");
		default:
			return translate("Sábado");
		}
	};

	useImperativeHandle(ref, () => ({
		getInnerData: () => spreadsheetRef.current?.getInnerData()
	}));

	const Schedule = useMemo(() => <RCCSpreadsheet
		ref={spreadsheetRef}
		styleInline=".jexcel > tbody > tr > td input[type='checkbox']{ width: auto !important; }"
		data={data.length > 0 ? data.map((dt: string[], idx: number) => {
			const returnObj = [...dt];
			returnObj.shift();
			return [
				getFirstColumn(idx),
				...returnObj
			];
		}) : defaultStateSchedule}
		onChange={(instance: any, cell: any, col: any, row: any, val: any) => {
			if(!spreadsheetRef.current)
				return;

			let grid = JSON.parse(JSON.stringify(spreadsheetRef.current.getInnerData()));
			const numberCol = Number(col);
			const numberRow = Number(row);

			if (numberRow === 0 && numberCol === 25) {
				const gridAll = [];
    
				for (let z = 0; z < 8; z += 1) {
					const arrayValores = GetArray(25, val);
					arrayValores.unshift(grid[z][0]);
					gridAll.push(arrayValores);
				}
    
				grid = gridAll;
    
			} else {
    
				if (numberCol === 25) {
					const arrayValue = GetArray(25, val);
					const gridRow = grid[numberRow];
					arrayValue.unshift(gridRow.shift());
					grid[numberRow] = arrayValue;
				}
    
				if (numberRow === 0) {
					grid.forEach((elem: any) => {
						// eslint-disable-next-line no-param-reassign
						elem[numberCol] = val;
					});
				}
    
				// atualiza
				spreadsheetRef.current.setData(grid);
				grid = JSON.parse(JSON.stringify(spreadsheetRef.current.getInnerData()));
    
				// verifica se tem que setar o todos
				const arraySemanaInteira = grid.shift(); // remove a linha semana inteira
    
				grid.forEach((linha: any, index: any) => {
    
					// executa uma vez
					if (index === 0) {
						for (let i = 1; i < linha.length; i += 1) {
							const colGrid = JSON.parse(JSON.stringify(spreadsheetRef.current?.getColumnData(i)));
							colGrid.shift();
							const allTrueCol = colGrid.every((y: any) => y === true); // verifica se todo estão marcados
							arraySemanaInteira[i] = allTrueCol;
						}
					}
    
					const diaSemana = linha.shift(); // tira o dia
					linha.pop(); // tira o checkbok do dia inteiro
    
					const allTrueRow = linha.every((x: any) => x === true); // verifica se todo estão marcados
					linha.push(allTrueRow);
					linha.unshift(diaSemana);
				});
    
				grid.unshift(arraySemanaInteira);
			}
    
			// atualiza
			spreadsheetRef.current.setData(grid);
		}}
		columns={[
			{ type: "text", title: " ", width: 100, readOnly: true },
			{ type: "checkbox", title: "0", width: 30 },
			{ type: "checkbox", title: "1", width: 30 },
			{ type: "checkbox", title: "2", width: 30 },
			{ type: "checkbox", title: "3", width: 30 },
			{ type: "checkbox", title: "4", width: 30 },
			{ type: "checkbox", title: "5", width: 30 },
			{ type: "checkbox", title: "6", width: 30 },
			{ type: "checkbox", title: "7", width: 30 },
			{ type: "checkbox", title: "8", width: 30 },
			{ type: "checkbox", title: "9", width: 30 },
			{ type: "checkbox", title: "10", width: 30 },
			{ type: "checkbox", title: "11", width: 30 },
			{ type: "checkbox", title: "12", width: 30 },
			{ type: "checkbox", title: "13", width: 30 },
			{ type: "checkbox", title: "14", width: 30 },
			{ type: "checkbox", title: "15", width: 30 },
			{ type: "checkbox", title: "16", width: 30 },
			{ type: "checkbox", title: "17", width: 30 },
			{ type: "checkbox", title: "18", width: 30 },
			{ type: "checkbox", title: "19", width: 30 },
			{ type: "checkbox", title: "20", width: 30 },
			{ type: "checkbox", title: "21", width: 30 },
			{ type: "checkbox", title: "22", width: 30 },
			{ type: "checkbox", title: "23", width: 30 },
			{ type: "checkbox", title: translate("Dia Inteiro"), width: 70 }
		]}
	/>, []);

	return Schedule;
};

export default forwardRef(ScheduleRestriction);
